import classNames from 'classnames';
import { PropsWithChildren } from 'react';

export interface PurposeProps extends PropsWithChildren {
  title?: string;
  description?: string;
  className?: string;
}
export const Purpose = ({
  title,
  description,
  className,
  children,
}: PurposeProps) => {
  const purposeClass = classNames('purpose', className);
  return (
    <div className={'purpose__wrapper'}>
      <div className={purposeClass}>
        <div className={'purpose__title'}>{title}</div>
        <div className={'purpose__description'}>{description}</div>
      </div>
      {children && <div className={'purpose__children'}>{children}</div>}
    </div>
  );
};
